<template>
  <div>
    <van-dialog
      v-model="show"
      title="标题"
      show-cancel-button
    >
      <img class="c-w-20" src="https://img01.yzcdn.cn/vant/apple-3.jpg" />
    </van-dialog>
  </div>
</template>

<script>
export default {
  name: "GDialog",
  props: {

  },
  data() {
    return {
        show: true
    };
  },
  created() {

  },
  mounted() {

  },
  methods: {

  }
};
</script>
<style scoped lang='scss'>
</style>
